module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-28.7fe33fa4.png";